<template>
    <div class="notes-toolbar">
        <div class="notes-toolbar__add">
            <NotesAdd
                :book-id="book.id"
                :part-id="bookpart.id"
                :local-id="bookpart.local_id"
                :text="bookpart.raw_text"
                :time-stamps="timeStamps"
                @added="added"
            />
        </div>
        <div v-if="routerLink" class="notes-toolbar__router">
            <router-link
                :to="routerLink"
                class="button button--blank"
                v-text="$t('notes.router.text')"
            />
        </div>
    </div>
</template>

<script>
import NotesAdd from '../NotesAdd/NotesAdd';
import { getNotes } from '../../api/notes';

export default {
    name: 'NotesToolbar',
    components: {
        NotesAdd
    },
    props: {
        book: {
            required: true,
            type: Object
        },
        bookpart: {
            required: true,
            type: Object
        },
        countChecking: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            notesList: [],
            notesCount: 0
        };
    },
    computed: {
        timeStamps() {
            const { duration: end, audio_generation_extra } = this.bookpart;
            const chunks = (audio_generation_extra && audio_generation_extra.trim_chunks) || [];

            if (chunks.length) {
                const { start, end } = chunks[0];
                return { start, end };
            }

            return { start: 0, end };
        },
        routerLink() {
            if (this.countChecking && !this.notesCount) return null;
            return `/editor/${this.$route.params.id}/notes`;
        }
    },
    created() {
        if (this.countChecking) this.fetchNotes(this.book.id);
    },
    methods: {
        async fetchNotes(book) {
            try {
                const params = { book };
                const { result, count } = await getNotes(params);
                this.notesList = result;
                this.notesCount = count;
            } catch (e) {
                console.log(e);
            }
        },
        added() {
            this.notesCount++;
        }
    }
};
</script>

<style src="./NotesToolbar.scss" lang="scss"></style>
